import { useState } from 'react';
import './CostATIS.css';

type DrillLevel = 'total' | 'provider' | 'service' | 'model' | 'mission' | 'agent' | 'receipt';

const drillData = {
  provider: [
    { name: 'DeepSeek', cost: 10, next: 'service' },
    { name: 'Grok', cost: 5, next: 'service' },
    { name: 'Other APIs', cost: 10, next: 'service' },
  ],
  service: [
    { name: 'DeepSeek Chat', cost: 8, next: 'model' },
    { name: 'DeepSeek Coder', cost: 2, next: 'model' },
  ],
  model: [
    { name: 'deepseek-chat-v3', cost: 8, next: 'mission' }
  ],
  mission: [
    { name: 'Flight One Demo', cost: 6, next: 'agent' },
    { name: 'Cost ATIS Build', cost: 2, next: 'agent' }
  ],
  agent: [
    { name: 'MiniMax M3', cost: 4, next: 'receipt' },
    { name: 'Sonnet', cost: 2, next: 'receipt' }
  ],
  receipt: [
    { name: 'receipt_20260722T1234.json', cost: 2, next: null },
    { name: 'receipt_20260722T1235.json', cost: 2, next: null }
  ]
};

export function CostATIS() {
  const [drillPath, setDrillPath] = useState<{level: DrillLevel, label: string, cost: number}[]>([{ level: 'total', label: 'Maximum configured', cost: 25 }]);

  const currentLevel = drillPath[drillPath.length - 1].level;
  
  const handleDrill = (level: DrillLevel, label: string, cost: number) => {
    if (level === 'total') return;
    setDrillPath(prev => [...prev, { level, label, cost }]);
  };

  const handleBreadcrumb = (index: number) => {
    setDrillPath(prev => prev.slice(0, index + 1));
  };

  return (
    <div className="cost-atis">
      <div className="cost-atis__header">
        <h3>AEVION FOUNDER OPERATING PICTURE</h3>
      </div>
      
      <div className="cost-atis__section">
        <h4>Recurring infrastructure</h4>
        <dl>
          <div><dt>Cloudflare</dt><dd>$0</dd></div>
          <div><dt>DigitalOcean</dt><dd>$0</dd></div>
          <div><dt>GCP</dt><dd>$0</dd></div>
          <div><dt>IBM</dt><dd>$0</dd></div>
        </dl>
      </div>

      <div className="cost-atis__section">
        <h4>Variable API budget</h4>
        <div className="cost-atis__drilldown">
          <div className="drilldown-breadcrumbs">
            {drillPath.map((node, i) => (
              <span key={i}>
                <button onClick={() => handleBreadcrumb(i)} className={i === drillPath.length - 1 ? 'active' : ''}>
                  {node.label} (${node.cost})
                </button>
                {i < drillPath.length - 1 && <span className="separator">↓</span>}
              </span>
            ))}
          </div>
          
          {currentLevel !== 'total' && currentLevel !== 'receipt' && drillData[currentLevel as keyof typeof drillData] && (
            <div className="drilldown-options">
              {(drillData[currentLevel as keyof typeof drillData] as any[]).map((item, i) => (
                <button key={i} className="drilldown-item" onClick={() => handleDrill(item.next, item.name, item.cost)}>
                  <span>{item.name}</span>
                  <span>${item.cost}</span>
                </button>
              ))}
            </div>
          )}
          
          {currentLevel === 'total' && (
            <div className="drilldown-options">
               <button className="drilldown-item" onClick={() => handleDrill('provider', 'API Providers', 25)}>
                  <span>API Providers</span>
                  <span>$25</span>
                </button>
            </div>
          )}

          {currentLevel === 'receipt' && (
             <div className="drilldown-options">
                <div className="receipt-view">
                  <code>&quot;evidence&quot;: &quot;verified&quot;</code>
                </div>
             </div>
          )}
        </div>
      </div>

      <div className="cost-atis__section">
        <dl>
          <div><dt>Unused active resources</dt><dd>0</dd></div>
        </dl>
      </div>

      <div className="cost-atis__section">
        <h4>Credits</h4>
        <dl>
          <div><dt>GCP application</dt><dd className="status-pending">PENDING</dd></div>
          <div><dt>Founder perks</dt><dd className="status-available">AVAILABLE</dd></div>
        </dl>
      </div>

      <div className="cost-atis__footer">
        <dl>
          <div><dt>Projected monthly cloud max</dt><dd>$25</dd></div>
        </dl>
      </div>
    </div>
  );
}
